// User stripe
export const SET_STRIPE = "SET_STRIPE";
//Payment MEthod and Intent
export const PAYMENT_INTENT_SUCCESS = "PAYMENT_INTENT_SUCCESS";
export const PAYMENT_INTENT_FAILURE = "PAYMENT_INTENT_FAILURE";

export const CLIENT_KEY_SUCCESS = "CLIENT_kEY_SUCCESS";
export const CLIENT_KEY_FAILURE = "CLIENT_kEY_FAILURE";